import { getMessages, getSentMessages } from '../../../../../Services/Inbox.js';
import DialogModal from '../../../../Modals/dialogModal.jsx';

import './Inbox.css';
import PreView from '../../Elements/PreView/PreView.jsx';
import PaginateControls from '../../Elements/PaginateControls/PaginateControls.jsx';
import { useEffect, useState } from 'react';
import useDebounce from '../../../../../Hooks/useDebounce.jsx';

var current = 1;
const Inbox = (props) => {

    const [inboxElements, setInboxElements] = useState([]);
    const [paginateControlsState, setPaginateControlsState] = useState({ next: false, prev: false });
    const [isPrevPage, setIsPrevPage] = useState(false);
    const [isNextPage, setIsNextPage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [searchName, setSearchName] = useState("");
    const [searchMessage, setSearchMessage] = useState("");

    const loadInboxData = async () => {

        let rsp;
        if (props.selected === 0) {
            rsp = await getMessages({page:current, name: searchName, title: searchMessage});
        } else {
            rsp = await getSentMessages({page:current, name: searchName, title: searchMessage});
        }

        if (rsp?.Error === false) {
            setIsPrevPage(rsp.Data.prev_page_url != null);
            setIsNextPage(rsp.Data.next_page_url != null);
            setInboxElements(rsp.Data.data);
        } else {
            setShowModal(true);
        }
        props.setIsLoading(false);
    }

    const changeCurrentPage = (num) => {
        current = current + num;
        loadInboxData();
    }


    const debounceLoadInboxData = useDebounce(loadInboxData, 500);

    useEffect(() => {
        loadInboxData();
    }, []);

    // TODO Implementar uso de estos estados de filtro en las llamadas al service
    useEffect(() => {
        debounceLoadInboxData();
    }, [searchName, searchMessage])

    return (
        <>
            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>No se pudieron cargar los datos en este momento.</h3>
            </DialogModal>
            {
                !props.isLoading ?
                    <>
                        <div className='input-search-contact-div'>
                            <label className='buzon-search-label'>Usuario</label>
                            <input type="text" className='input-search-contact' placeholder='Buscar...' onChange={e => { setSearchName(e.target.value) }} />
                        </div>
                        <div className='input-search-contact-div'>
                            <label className='buzon-search-label'>Asunto</label>
                            <input type="text" className='input-search-contact' placeholder='Buscar...' onChange={e => { setSearchMessage(e.target.value) }} />
                        </div>
                        {
                            inboxElements.map((item, index) => {
                                return (
                                    <PreView messege={item} key={index} setSelectedType={props.setSelectedType} />
                                );
                            })
                        }
                        {inboxElements.length === 0 && <h5 style={{ textAlign: 'center', margin: 10 }}>No tiene mensajes.</h5>}

                        <PaginateControls next={isNextPage} prev={isPrevPage} callback={changeCurrentPage} />
                    </>
                    :
                    <></>
            }
        </>
    );
}

export default Inbox;